import { usePageContext } from 'application/contexts/PageContext';
import { useSiteContext } from 'application/contexts/SiteContext';
import { CatalogListItemProps } from 'designsystem/components/2-molecules/CatalogListItem';
import { RelatedList } from 'designsystem/components/3-organisms/RelatedList';
import { CludoLang } from 'features/Layouts/Layout/Vendors/Cludo';
import { getElasticIndexName } from 'features/Layouts/Layout/Vendors/Elastic/elasticHelpers';
import { useElasticSearch } from 'hooks/useElasticSearch';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { LinkFeature } from '../Link';

export const relatedDefaultLimit = 3;
export interface RelatedListFeatureProps {
	limit?: number;
	parentId: string;
	heading: string;
	tags?: string[];
	types?: string[];
}

export const RelatedListFeature: React.FC<RelatedListFeatureProps> = ({ limit = relatedDefaultLimit, parentId, heading, tags, types }) => {
	const siteContext = useSiteContext();
	const pageContext = usePageContext();
	const router = useRouter();

	const { theme } = siteContext ?? {};
	const lang = router.locale.split('-')[0] as CludoLang;

	const { results: relatedPages } = useElasticSearch({
		index: getElasticIndexName(theme, lang),
		parentId: parentId,
		query: '*',
		tags: tags,
		types: types,
		limit: limit + 1, // In case of related news being the same page
		operatorForTagsAndTypes: 'or',
		sort: 'default',
	});
	const relatedNavigationItems: Navigation.NavigationItem[] = relatedPages?.map((item, index) => {
		if (item.link?.url !== window.location.href) {
			const liExpirationDate = new Date((item as Models.CatalogListItem)?.expirationDate);
			if (!(item as Models.CatalogListItem)?.expirationDate || liExpirationDate.getTime() > new Date().getTime()) {
				return {
					id: index,
					name: item.heading,
					description: item.teaser,
					url: item.link?.url,
					link: <LinkFeature url={item.link?.url} />,
				};
			}
		}
	});
	useEffect(() => {
		if (document.activeElement instanceof HTMLElement) {
			document.activeElement.blur();
		}
	}, [router]);

	const relatedNavigationItemsWithoutSelf = relatedNavigationItems?.filter((article) => {
		return article?.url !== pageContext?.url ? article : false;
	});

	return relatedNavigationItemsWithoutSelf?.length > 0 ? (
		<RelatedList
			heading={heading}
			items={relatedNavigationItemsWithoutSelf
				?.map((navItem): CatalogListItemProps => {
					const { name: heading, url, description, date } = navItem ?? {};
					return {
						heading,
						link: <LinkFeature url={url} title={heading} />,
						teaser: description?.length > 150 ? `${description.substring(0, 150)}…` : description,
						date,
					};
				})
				?.slice(0, limit)}
		/>
	) : null;
};
